const ESTIMATED_VALUE_MAX = 99999999;

export default {
  validate: (value, { minValue }) => ({
    required: true,
    valid: /^-?[0-9]+$/.test(value) && Number(minValue) <= Number(value) && Number(value) <= ESTIMATED_VALUE_MAX,
  }),
  params: ['minValue'],
  message: (fieldName, { _value_: v, minValue }) => {
    if (!v) return 'Please enter the estimated value of fitted accessories.';
    if (!/^-?[0-9]+$/.test(v)) return 'Please only enter numbers e.g. £5000.';
    if (Number(v) < Number(minValue)) return `The estimated value of fitted accessories must be greater than £${minValue}.`;
    if (Number(v) > ESTIMATED_VALUE_MAX) return `The estimated value of fitted accessories must be between £${minValue} and £${ESTIMATED_VALUE_MAX}.`;
    return 'Please enter the estimated value of fitted accessories.';
  },
  computesRequired: true,
};
